<script setup>
import { computed } from 'vue'

const props = defineProps({ tone: { type: String, default: 'gray' }, icon: { type: String, default: '' }, dot: Boolean })
const tones = {
  gray: 'bg-slate-100 text-slate-700 dark:bg-slate-700/40 dark:text-slate-200',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  green: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  red: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  violet: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200',
  brand: 'bg-brand-100 text-brand-800 dark:bg-brand-900/50 dark:text-brand-200',
}
const cls = computed(() => tones[props.tone] || tones.gray)
</script>

<template>
  <span :class="['inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap', cls]">
    <span v-if="dot" class="h-1.5 w-1.5 rounded-full bg-current opacity-70"></span>
    <i v-if="icon" :class="['fa-solid', icon, 'text-3xs']" aria-hidden="true"></i>
    <slot />
  </span>
</template>
